import { render, staticRenderFns } from "./TransitionChangeForm.vue?vue&type=template&id=7ac524b4&lang=pug&"
import script from "./TransitionChangeForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./TransitionChangeForm.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports